(ns portal.delivery-table.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/CircularProgress$default" :as CircularProgress]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium GridOverlay]]
            [common.util :as util]
            [common.widgets.data-grid :as dg]
            [portal.messages :refer [ui-messages]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(def columns
  #js [#js {:field "month"
            :headerName "Month"
            :sortable true
            :filterable true
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:month row))
            :renderCell (fn [^js params]
                          (let [value (.-value params)]
                            (util/->month-name value)))
            :flex 1}
       #js {:field "year"
            :headerName "Year"
            :sortable true
            :filterable true
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:year row))
            :flex 1}
       #js {:field "display"
            :headerName "Display"
            :sortable true
            :filterable true
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:display row))
            :renderCell (fn [^js params]
                          (let [value (.-value params)]
                            (util/->locale-string value)))
            :flex 1}
       #js {:field "vast"
            :headerName "VAST"
            :sortable true
            :filterable true
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:video row))
            :renderCell (fn [^js params]
                          (let [value (.-value params)]
                            (util/->locale-string value)))
            :flex 1}
       #js {:field "native"
            :headerName "Native"
            :sortable true
            :filterable true
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:native row))
            :renderCell (fn [^js params]
                          (let [value (.-value params)]
                            (util/->locale-string value)))
            :flex 1}
       #js {:field "total"
            :headerName "Total"
            :sortable true
            :filterable true
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           ((comp (partial apply +) (juxt :display :video :native)) row))
            :renderCell (fn [^js params]
                          (let [value (.-value params)]
                            (util/->locale-string value)))
            :flex 1}])

(def LoadingOverlay
  (uix/as-react
   (fn [{:keys [entity]}]
     ($ GridOverlay
        {:sx #js {:flexDirection "column"
                  :gap 1}}
        ($ CircularProgress)
        ($ :span (get-in ui-messages [:delivery entity :pending]))))))

(def Toolbar
  (uix/as-react
   (fn [{:keys [selected]}]
     ($ dg/grid-toolbar
        {:hide-quick-filter true
         :sx #js {:justifyContent "flex-end"}}
        ($ Tooltip {:disableHoverListener (boolean (seq selected))
                    :title (get-in ui-messages [:delivery :details :hint])}
           ($ :span
              ($ Button
                 {:variant "contained"
                  :color "grey"
                  :disabled (empty? selected)
                  :startIcon ($ Icon "file_download")
                  :onClick #(rf/dispatch [:table.delivery/get-details selected])}
                 "Download detailed report")))))))

(defui table []
  (let [{:keys [state value entity]} (use-subscribe [:table.delivery/unpaginated-value])
        {page-size :size} (use-subscribe [:table.delivery/page])
        get-row-id (fn [row] (str (:month row) "/" (:year row)))
        selected (use-subscribe [:table.delivery/selected-rows])]
    ($ DataGridPremium
       {:columns columns

        :loading (or (nil? state) (= state :pending))

        :rows (to-array value)
        :getRowId get-row-id

        :checkboxSelection true
        :rowSelectionModel (clj->js (use-subscribe [:table.delivery/selected-rows]))
        :onRowSelectionModelChange (fn [^js selection] (rf/dispatch [:table.delivery/select-rows (js->clj selection)]))

        :pagination true
        :pageSizeOptions #js [page-size]

        :initialState #js {:pagination #js {:paginationModel #js {:pageSize page-size}}}
        :slots #js {:loadingOverlay LoadingOverlay
                    :toolbar Toolbar}
        :slotProps #js {:filterPanel #js {:data-testid "filterPanel"
                                          :filterFormProps #js {:data-testid "filterForm"
                                                                :columnInputProps #js {:data-testid "columnInput"}
                                                                :operatorInputProps #js {:data-testid "operatorInput"}
                                                                :valueInputProps #js {:data-testid "valueInput"}}}
                        :toolbar #js {:selected selected}
                        :loadingOverlay #js {:entity entity}}
        :sx #js {:maxHeight "70rem"}})))
